import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static values = { tradingLogId: Number }

  toggleTag(event) {
    const button = event.currentTarget
    const tagName = button.dataset.tagName
    const isSelected = button.classList.contains('bg-blue-600') || button.classList.contains('dark:bg-blue-500')
    
    // 禁用按钮并显示加载状态
    button.disabled = true
    button.classList.add('opacity-50')
    
    // 发送请求
    const action = isSelected ? 'remove' : 'add'
    this.sendTagRequest(action, tagName, button)
  }

  async sendTagRequest(action, tagName, button) {
    try {
      const response = await fetch(`/trading_logs/${this.tradingLogIdValue}`, {
        method: 'PATCH',
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded',
          'X-CSRF-Token': document.querySelector('meta[name="csrf-token"]').content,
          'Accept': 'application/json'
        },
        body: new URLSearchParams({
          'tag_action': action,
          'tag_name': tagName
        })
      })

      if (response.ok) {
        const data = await response.json()
        
        // 更新按钮样式
        this.updateButtonState(button, action === 'add')
        
        // 显示成功消息
        this.showMessage(data.message, 'success')
      } else {
        throw new Error('请求失败')
      }
    } catch (error) {
      console.error('标签操作失败:', error)
      this.showMessage(`操作失败: ${error.message}`, 'error')
    } finally {
      // 恢复按钮状态
      button.disabled = false
      button.classList.remove('opacity-50')
    }
  }

  updateButtonState(button, isSelected) {
    const icon = button.querySelector('svg')
    
    if (isSelected) {
      // 已选择状态 - 深蓝色背景白色文字
      button.className = 'px-3 py-2 text-xs font-medium rounded-lg border transition-all duration-200 shadow-sm bg-blue-600 text-white border-blue-600 shadow-blue-200 hover:bg-blue-700 hover:shadow-blue-300 dark:bg-blue-500 dark:border-blue-500 dark:shadow-blue-900/50 dark:hover:bg-blue-600'
      
      // 更新图标为实心勾选
      icon.outerHTML = '<svg class="w-3 h-3 inline mr-1.5" fill="currentColor" viewBox="0 0 24 24"><path d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z"/></svg>'
    } else {
      // 未选择状态 - 白色背景灰色文字
      button.className = 'px-3 py-2 text-xs font-medium rounded-lg border transition-all duration-200 shadow-sm bg-white text-gray-600 border-gray-300 hover:bg-gray-50 hover:border-gray-400 hover:text-gray-800 hover:shadow-md dark:bg-gray-800 dark:text-gray-300 dark:border-gray-600 dark:hover:bg-gray-700 dark:hover:border-gray-500'
      
      // 更新图标为半透明加号
      icon.outerHTML = '<svg class="w-3 h-3 inline mr-1.5 opacity-60" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 6v6m0 0v6m0-6h6m-6 0H6"></path></svg>'
    }
  }

  showMessage(message, type) {
    // 创建消息提示
    const messageEl = document.createElement('div')
    messageEl.className = `fixed top-4 right-4 px-4 py-2 rounded-lg text-sm font-medium z-50 ${
      type === 'success' 
        ? 'bg-green-100 text-green-800 border border-green-200' 
        : 'bg-red-100 text-red-800 border border-red-200'
    }`
    messageEl.textContent = message
    
    document.body.appendChild(messageEl)
    
    // 3秒后自动移除
    setTimeout(() => {
      if (messageEl.parentNode) {
        messageEl.parentNode.removeChild(messageEl)
      }
    }, 3000)
  }
}